<template>
  <div class="drawer">
    <div class="drawer-container">
      <div
        class="drawer-content"
        :class="settlement.payoffAt == null ? 'with-footer' : ''"
      >
        <el-form
          ref="settlementForm"
          :model="settlement"
          class="box"
          label-width="110px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.title')">{{
                  settlement.title
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.suppliers')">{{
                  settlement.supplierName
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.direction')">{{
                  $t("settlement.directionsSupplier." + settlement.settleType)
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.purchaseQuantity')">{{
                  settlement.orderQuantity
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.productQuantity')">{{
                  settlement.productQuantity
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.createAt')">{{
                  settlement.settleAt
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.amount')">
                  {{ settlement.amount | currency }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.giveAmountPayAmount')">
                  {{ settlement.giveAmount | currency }}/{{
                    settlement.payAmount | currency
                  }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.diffAmount')">
                  <span
                    v-if="
                      settlement.payoffAt == null &&
                      settlement.amount - settlement.giveAmount > 0
                    "
                  >
                    {{ (settlement.amount - settlement.giveAmount) | currency }}
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col v-if="settlement.selfVerifyAt != null" :span="8">
                <el-form-item :label="$t('settlement.selfVerifyAt')">{{
                  settlement.selfVerifyAt
                }}</el-form-item>
              </el-col>
              <el-col v-if="settlement.verifyAt != null" :span="8">
                <el-form-item :label="$t('settlement.verifyAt')">{{
                  settlement.verifyAt
                }}</el-form-item>
              </el-col>
              <el-col v-if="settlement.payoffAt != null" :span="8">
                <el-form-item :label="$t('settlement.payoffAt')">{{
                  settlement.payoffAt
                }}</el-form-item>
              </el-col>
            </el-row>
            <div class="search-condition-div">
              {{ $t("settlement.searchCondition") }}:{{
                settlement.searchCondition
              }}
            </div>
            <div class="font8 orange" v-if="settlement.settleType == 'Order'">
              *创建日期 对应 我的外采单 下单日期<br />
              *交货完成日期 对应 我的外采单 供应商发货日期<br />
              *客户收货日期 对应 我的外采单 收货完成日期
            </div>
          </fieldset>

          <fieldset class="mgb10">
            <legend>
              {{ $t("settlement.paymentInfo") }}
              <el-button
                v-if="settlement.payoffAt == null"
                type="success"
                plain
                size="mini"
                @click="addPayment"
                >+ {{ $t("action.paymentPay") }}</el-button
              >
            </legend>
            <vxe-table
              :data="payments"
              size="mini"
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="total"
                :title="$t('payment.total')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <currency :code="row.currency"></currency>
                  {{ row.total }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="payMethodName"
                :title="$t('payment.payMethod')"
                min-width="100"
              ></vxe-table-column>
              <vxe-table-column
                field="paidAt"
                :title="$t('payment.paidAt')"
                min-width="110"
              ></vxe-table-column>

              <vxe-table-column
                field="voucher"
                :title="$t('payment.voucher')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <thumbnail-text :srcs="row.voucher" />
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="explain"
                :title="$t('payment.explain')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number :content="row.explain" :number="8" />
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="confirmAt"
                :title="$t('order.confirmAt')"
                min-width="110"
              ></vxe-table-column>
              <vxe-table-column
                field="action"
                :title="$t('text.action')"
                width="50"
              >
                <template v-slot="{ row }">
                  <el-button
                    v-if="row.confirmAt == null && settlement.payoffAt == null"
                    type="text"
                    size="mini"
                    @click="deletePayment(row)"
                    >{{ $t("text.delete") }}</el-button
                  >
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
          <!-- <fieldset class="mgb10">
            <legend>
              {{ $t("text.detail") }}
              <el-button type="default" size="mini" @click="download">{{
                $t("action.download")
              }}</el-button>
              <span
                v-if="
                  items.filter(
                    (p) => p.purchase && p.purchase.manualSettleAt != null
                  ).length != 0
                "
                class="orange font10"
              >
                共{{ items.length }}条,{{
                  items.filter(
                    (p) => p.purchase && p.purchase.manualSettleAt != null
                  ).length
                }}条标记结算
              </span>
            </legend>
            <vxe-table
              :data="items"
              ref="itemsTable"
              class="recordsTable"
              size="mini"
              :scroll-y="{ enabled: false }"
              highlight-hover-row
            >
              <vxe-table-column type="expand" width="30px">
                <template v-slot:content="{ row }">
                  <el-row>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("text.createAt") }}:
                      </span>
                      {{ row.purchase.createAt }}
                    </el-col>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("text.handOverAt") }}:
                      </span>
                      {{ row.purchase.handOverAt }}
                    </el-col>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("purchase.giveAt") }}:
                      </span>
                      {{ row.purchase.giveAt }}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("purchase.finishAt") }}:
                      </span>
                      {{ row.purchase.finishAt }}
                    </el-col>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("purchase.supplierDeliveryAt") }}:
                      </span>
                      {{ row.purchase.supplierDeliveryAt }}
                    </el-col>
                    <el-col
                      v-if="row.purchase.manualSettleAt != null"
                      :span="8"
                    >
                      <span class="expand-field-title">
                        {{ $t("purchase.supplierDeliveryAt") }}:
                      </span>
                      {{ row.purchase.manualSettleAt }}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("product.category") }}:
                      </span>
                      {{ row.purchase.categoryName }}
                    </el-col>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("product.brand") }}:
                      </span>
                      {{ row.purchase.productBrand }}
                    </el-col>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("action.downloadAttatchment") }}:
                      </span>
                      <a
                        v-if="row.purchase.attachment"
                        class="blue"
                        target="_blank"
                        :href="row.purchase.attachment"
                      >
                        {{ $t("action.downloadAttatchment") }}
                      </a>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("product.specJson") }}:
                      </span>
                      <attribute
                        :content="row.purchase.specJson"
                        :number="16"
                      />
                    </el-col>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("product.craftwork") }}:
                      </span>
                      <raw-html-limit-number
                        :content="row.purchase.craftwork"
                        :number="16"
                        type="richText"
                      />
                    </el-col>
                    <el-col :span="8">
                      <span class="expand-field-title">
                        {{ $t("text.remark") }}:
                      </span>
                      <raw-html-limit-number
                        :content="row.purchase.remark"
                        :number="16"
                        type="richText"
                      />
                    </el-col>
                  </el-row>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="images"
                :title="$t('product.images')"
                width="85"
              >
                <template v-slot="{ row }">
                  <thumbnail :images="row.purchase.images"></thumbnail>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="serialNo"
                :title="$t('text.serialNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.purchase.serialNo }}
                  <div>
                    <state-label :state="row.purchase.workflowState">{{
                      $t("purchaseStates." + row.purchase.workflowState)
                    }}</state-label>
                    <span
                      v-if="row.purchase.manualSettleAt !== null"
                      class="green font10"
                      >{{ $t("delivery.settle") }}</span
                    >
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="productNo"
                :title="$t('product.productNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.purchase.productNo }}
                  <div class="font10">
                    {{ row.purchase.color }} {{ row.purchase.size }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.purchase.quantity }}{{ row.purchase.unit }}
                  <div class="font10">
                    {{ row.purchase.price | currency }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column :title="$t('order.subtotal')" min-width="80">
                <template v-slot="{ row }">
                  {{ (row.purchase.price * row.purchase.quantity) | currency }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                :title="$t('settlement.settleTotal')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  {{ row.settleTotal | currency }}
                  <div class="font10">
                    {{ $t("text.explain") }}:
                    <raw-html-limit-number :content="row.explain" :number="8" />
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="verifyAt"
                :title="$t('settlement.verifyAt')"
                min-width="110"
              >
                <template v-slot="{ row, rowIndex }">
                  {{ row.verifyAt }}
                  <div class="font10">
                    <i
                      v-if="
                        row.verifyAt == null && settlement.settleType == 'Order'
                      "
                      slot="reference"
                      class="el-icon-edit fl"
                      @click="editVerifyExplain(row, rowIndex)"
                    />
                    {{ $t("settlement.verifyExplain") }}:
                    <raw-html-limit-number
                      :content="row.verifyExplain"
                      :number="8"
                    />
                  </div>
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="action"
                :title="$t('text.action')"
                width="90"
              >
                <template v-slot="{ row }">
                  <span v-if="row.verifyAt == null">
                    <el-button
                      v-if="settlement.settleType == 'Purchase'"
                      type="text"
                      size="mini"
                      @click="editItem(row)"
                      >{{ $t("text.edit") }}</el-button
                    >
                    <el-button
                      v-if="settlement.settleType == 'Purchase'"
                      type="text"
                      size="mini"
                      @click="deleteItem(row)"
                      >{{ $t("text.remove") }}</el-button
                    >
                    <div>
                      <el-button
                        v-if="settlement.settleType == 'Order'"
                        size="mini"
                        type="text"
                        @click="verifyItem(row)"
                        >{{ $t("action.verify") }}</el-button
                      >
                    </div>
                  </span>
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset> -->
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="settlement.payoffAt == null"
        type="primary"
        plain
        size="small"
        @click="confirmPayOff"
        >{{ $t("action.paymentOff") }}</el-button
      >
    </div>

    <!-- 添加收款 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.addPayment')"
      :visible.sync="addPaymentDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="addPaymentObjForm"
        :model="addPaymentObj"
        label-width="80px"
      >
        <el-form-item
          :prop="'total'"
          :label="$t('payment.total')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.total')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="addPaymentObj.total" />
        </el-form-item>
        <el-form-item
          :label="$t('payment.payMethod')"
          :prop="'payMethodId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.payMethod')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="addPaymentObj.payMethodId"
            clearable
            filterable
          >
            <el-option
              v-for="payMethod in payMethods"
              :key="payMethod.id"
              :label="payMethod.name"
              :value="payMethod.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          :prop="'explain'"
          :label="$t('payment.explain')"
        >
          <el-input
            size="small"
            v-model.trim="addPaymentObj.explain"
            type="textarea"
            :rows="2"
          />
        </el-form-item>
        <el-form-item :label="$t('payment.voucher')" :prop="'voucher'">
          <dropzone v-model="addPaymentObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="addPaymentDoing"
          size="small"
          @click="addPaymentSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addPaymentDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑Item -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :visible.sync="editItemDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="editItemForm" :model="editItemObj" label-width="80px">
        <el-form-item
          :prop="'settleTotal'"
          :label="$t('settlement.settleTotal')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('settlement.settleTotal')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editItemObj.settleTotal" />
        </el-form-item>

        <el-form-item :prop="'explain'" :label="$t('settlement.explain')">
          <el-input
            size="small"
            v-model.trim="editItemObj.explain"
            type="textarea"
            :rows="2"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editItemDoing"
          size="small"
          @click="editItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑对账说明 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('settlement.verifyExplain')])"
      :close-on-click-modal="false"
      :visible.sync="editVerifyExplainDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          size="small"
          v-model.trim="editVerifyExplainObj.verifyExplain"
          type="textarea"
          :rows="2"
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editVerifyExplainDoing"
          size="small"
          @click="editVerifyExplainSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editVerifyExplainDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Currency from "@/components/Currency";
import ThumbnailText from "@/components/ThumbnailText";
import RawHtml from "@/components/RawHtml";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";

import Dropzone from "@/components/Dropzone";

import Settlement from "@/api/settlement.js";
import Payment from "@/api/payment.js";
import PayMethod from "@/api/payMethod.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    Currency,
    ThumbnailText,
    RawHtml,
    Dropzone,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      settlement: {},
      payments: [],
      items: [],
      // 添加收款
      payMethods: [],
      addPaymentDF: false,
      addPaymentObj: {
        total: null,
        payMethodId: null,
        payMethodName: null,
        explain: null,
        voucher: null,
        settlementId: null,
        currency: null,
        paidAt: new Date(),
      },
      addPaymentDoing: false,
      // 编辑Item
      editItemDF: false,
      editItemObj: {
        settleTotal: null,
        explain: null,
        settlementId: null,
      },
      row: null,
      editItemDoing: false,
      //编辑对账说明
      currentRowIdx: null,
      editVerifyExplainDF: false,
      editVerifyExplainObj: {
        verifyExplain: null,
      },
      editVerifyExplainDoing: false,
    };
  },
  mounted() {
    // 根据id请求bargain
  },
  created() {
    const self = this;
    self.loadingStart();
    Settlement.findById(self.id).then(function (res) {
      if (res.status === 200) {
        self.settlement = res.data;
      } else {
        self.sysError();
      }
      self.loadingEnd();
      self.getItems();
      self.getPayments();
    });
  },
  methods: {
    getSettlement() {
      const self = this;
      Settlement.findById(self.id).then(function (res) {
        if (res.status === 200) {
          self.settlement = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // 付款完毕
    confirmPayOff() {
      const self = this;
      if (self.settlement.amount > self.settlement.payAmount) {
        self.$message({
          message: "未付款完，不能标记完成",
          type: "warning",
        });
        return;
      }
      if (confirm(this.$t("prompt.confirmPayOff"))) {
        Settlement.payOff(self.settlement.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("action.paymentOff"),
              type: "success",
            });
            self.getSettlement();
            self.$emit("updateData");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑对账说明
    editVerifyExplain(row, rowIndex) {
      this.row = row;
      this.currentRowIdx = rowIndex;
      this.editVerifyExplainObj.verifyExplain = row.verifyExplain;
      this.editVerifyExplainDoing = false;
      this.editVerifyExplainDF = true;
    },
    editVerifyExplainSubmit() {
      const self = this;
      self.editVerifyExplainDoing = true;
      Settlement.updateVerifyExplain(
        self.settlement.id,
        self.row.id,
        self.editVerifyExplainObj
      ).then(function (res) {
        self.editVerifyExplainDoing = false;
        self.editVerifyExplainDF = false;
        if (res.status === 200) {
          self.items[self.currentRowIdx].verifyExplain =
            self.editVerifyExplainObj.verifyExplain;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },

    download() {
      const self = this;
      Settlement.exportExcelItem({
        settlementId: self.settlement.id,
        type: "Purchase",
      }).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 核对账单明细
    verifyItem(row) {
      const self = this;
      Settlement.verifyItem(self.settlement.id, row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.verifySuccess"),
            type: "success",
          });
          self.getItems();
          self.getSettlement();
        } else {
          self.sysError();
        }
      });
    },
    // 移除
    deleteItem(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmRemove"))) {
        Settlement.deleteItem(self.settlement.id, row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getItems();
            self.getSettlement();
            self.$emit("updateData");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑账单明细
    editItem(row) {
      const self = this;
      self.row = row;
      self.editItemObj.settleTotal = row.settleTotal;
      self.editItemObj.explain = row.explain;
      self.editItemObj.settlementId = this.settlement.id;
      self.editItemDoing = false;
      self.editItemDF = true;
    },
    editItemSubmit() {
      const self = this;
      this.$refs.editItemForm.validate((valid) => {
        if (valid) {
          self.editItemDoing = true;
          Settlement.updateItem(
            self.settlement.id,
            self.row.id,
            self.editItemObj
          ).then(function (res) {
            self.editItemDoing = false;
            self.editItemDF = false;
            self.$message({
              message: self.$t("prompt.editSuccess"),
              type: "success",
            });
            self.getItems();
            self.getSettlement();
            self.$emit("updateData");
          });
        } else {
          return false;
        }
      });
    },
    // 确认
    deletePayment(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Payment.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getPayments();
            self.getSettlement();
            self.$emit("updateData");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 添加收款
    addPayment() {
      const self = this;
      this.addPaymentObj.total =
        this.settlement.amount - this.settlement.giveAmount;
      this.addPaymentObj.payMethodId = null;
      this.addPaymentObj.payMethodName = null;
      this.addPaymentObj.explain = null;
      this.addPaymentObj.currency = this.settlement.currency;
      this.addPaymentObj.settlementId = this.settlement.id;
      this.addPaymentObj.paidAt = new Date();
      self.getPayMethods();
      this.addPaymentDoing = false;
      this.addPaymentDF = true;
    },
    getPayMethods() {
      const self = this;
      PayMethod.findByTypes({ types: PayMethod.saleTypes }).then(function (
        res
      ) {
        if (res.status === 200) {
          self.payMethods = res.data;
        } else {
          self.sysError();
        }
      });
    },
    addPaymentSubmit() {
      const self = this;
      this.$refs.addPaymentObjForm.validate((valid) => {
        if (valid) {
          self.addPaymentObj.payMethodName = self.payMethods.find(
            (p) => p.id === self.addPaymentObj.payMethodId
          ).name;
          self.addPaymentDoing = true;
          Payment.create(self.addPaymentObj).then(function (res) {
            self.addPaymentDoing = false;
            self.addPaymentDF = false;
            self.$message({
              message: self.$t("prompt.addSuccess"),
              type: "success",
            });
            self.getPayments();
            self.getSettlement();
            self.$emit("updateData");
          });
        } else {
          return false;
        }
      });
    },
    //
    getPayments() {
      const self = this;
      Payment.findBySettlementId(self.id).then(function (res) {
        if (res.status === 200) {
          self.payments = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getItems() {
      const self = this;
      Settlement.items(self.id, { type: "Purchase" }).then(function (res) {
        if (res.status === 200) {
          self.items = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getSettlement() {
      const self = this;
      Settlement.findById(self.id).then(function (res) {
        if (res.status === 200) {
          self.settlement = res.data;
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>